module.exports = __webpack_public_path__ + "static/media/loading-40px_1loading-40px.70119154.gif";